<template>
  <div id="app">
    <Header v-if="shouldShowHeader"  />
    <router-view/>
    <Footer v-if="shouldShowFooter"   />
  </div>
</template>

<script>
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';

export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      windowWidth: window.innerWidth
    }
  },
  computed: {
    isMobile() {
      // 检测是否为移动设备
      return window.innerWidth <= 900;
    },
    shouldShowFooter() {
      // 定义移动端不需要显示Footer的路由
      const mobileRoutesWithoutFooter = ['/product-center', '/app-center', '/result',];
  
       if ('/pdf-show' === this.$route.path) {
        return false;
      }
      // 如果是移动端且在指定路由上，则不显示Footer
      if (this.isMobile && mobileRoutesWithoutFooter.includes(this.$route.path)) {
        return false;
      }
      
      // 网页端始终显示Footer
      return true;
    },
    shouldShowHeader() {
      // 定义移动端不需要显示Header的路由
      const mobileRoutesWithoutHeader = [ '/pdf-show']; 
      
      // 如果是移动端且在指定路由上，则不显示Footer
      if (mobileRoutesWithoutHeader.includes(this.$route.path)) {
        return false;
      }
      
      // 网页端始终显示Footer
      return true;
    }
  },
  mounted() {
    // 在mounted中动态加载CSS文件可能会导致路由问题
    // 如果需要动态加载，建议在路由守卫中处理
    // 或者最好在index.html中直接引入CSS
    
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      // 更新窗口宽度以触发响应式更新
      this.windowWidth = window.innerWidth;
    }
  }
}
</script>

<style>
/* 全局样式已在index.html中引入 */
</style>